(function () {
  var STORAGE_KEY = 'r33_modal_dismissed_at';

  function initMedia(root) {
    var slot = root.querySelector('[data-media-slot]');
    if (!slot) return;
    var isMobile = window.matchMedia('(max-width:639px)').matches;
    var variant = isMobile ? 'mobile' : 'desktop';
    var tmpl = root.querySelector('.room33-modal__tmpl[data-variant="' + variant + '"]');
    var other = variant === 'mobile' ? 'desktop' : 'mobile';
    if (!tmpl || !tmpl.content || !tmpl.content.firstElementChild) {
      tmpl = root.querySelector('.room33-modal__tmpl[data-variant="' + other + '"]');
    }
    if (tmpl && tmpl.content && tmpl.content.firstElementChild) {
      slot.appendChild(tmpl.content.cloneNode(true));
    }
  }

  function initModal(root) {
    if (root._ready) return; root._ready = true;
    initMedia(root);
    var hideDays = parseFloat(root.getAttribute('data-hide-days')) || 1;
    var delay = parseFloat(root.getAttribute('data-delay')) || 4000;

    function dismissedRecently() {
      try {
        var t = localStorage.getItem(STORAGE_KEY);
        if (!t) return false;
        return (Date.now() - parseInt(t, 10)) < hideDays * 86400000;
      } catch (e) { return false; }
    }
    function open() { root.classList.add('is-open'); document.body.style.overflow = 'hidden'; }
    function close() {
      root.classList.remove('is-open'); document.body.style.overflow = '';
      try { localStorage.setItem(STORAGE_KEY, String(Date.now())); } catch (e) {}
    }
    root.querySelectorAll('[data-modal-close]').forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    if (!dismissedRecently()) setTimeout(open, delay);

    // countdown
    var cd = root.querySelector('.room33-modal__cd[data-target]');
    function tick() {
      if (!cd) return;
      var t = Date.parse(cd.getAttribute('data-target')); if (isNaN(t)) return;
      var d = Math.max(0, t - Date.now());
      var set = function (k, v) { var n = cd.querySelector('[data-unit="' + k + '"]'); if (n) n.firstChild.textContent = ('0' + v).slice(-2); };
      set('d', Math.floor(d / 86400000)); set('h', Math.floor((d % 86400000) / 3600000));
      set('m', Math.floor((d % 3600000) / 60000)); set('s', Math.floor((d % 60000) / 1000));
    }
    tick(); setInterval(tick, 1000);

    // Klaviyo email capture
    var form = root.querySelector('[data-klaviyo-form]');
    var msg = root.querySelector('[data-modal-msg]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var listId = form.getAttribute('data-list-id');
        var email = form.querySelector('input[name="email"]').value;
        var btn = form.querySelector('.room33-modal__submit');
        var label = btn.querySelector('[data-label]');
        if (!listId) { msg.textContent = 'Klaviyo List ID missing in section settings.'; msg.classList.add('is-error'); return; }
        btn.disabled = true; var prev = label.textContent; label.textContent = 'Sending...';
        var body = new URLSearchParams({ g: listId, email: email, $fields: 'email' });
        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST', mode: 'no-cors',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
          body: body.toString()
        }).then(function () {
          msg.textContent = 'You\u2019re on the list. Watch your inbox.'; msg.classList.remove('is-error'); msg.classList.add('is-ok');
          form.reset(); label.textContent = prev; btn.disabled = false;
          setTimeout(close, 1800);
        }).catch(function () {
          msg.textContent = 'Something went wrong — please try again.'; msg.classList.add('is-error');
          label.textContent = prev; btn.disabled = false;
        });
      });
    }
  }
  function scan(root) { (root || document).querySelectorAll('[data-modal]').forEach(initModal); }
  if (document.readyState !== 'loading') scan(); else document.addEventListener('DOMContentLoaded', function () { scan(); });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
